import { render, staticRenderFns } from "./CloudDownload.vue?vue&type=template&id=8fa52992"
import script from "./CloudDownload.vue?vue&type=script&lang=js"
export * from "./CloudDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports